import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextInputField } from "evergreen-ui";
import { useSelector } from "react-redux";
import { MagnifyingGlass, Bars } from "react-loader-spinner";
import styles from "./forgetPassword.module.css";
import {
  Captcha,
  generateString,
  validateCaptcha,
} from "../../Captcha/Captcha";
import { ToastContainer, toast } from "react-toastify";
import { saveData } from "../../../Utils/localStorage";
import { validateEmail } from "../../../Utils/Validation";
import { IMAGE_PATH, PRODUCT } from "../../../Utils/variables";
export const ForgetPassword = () => {
  document.title = PRODUCT + " - Forgot Password";
  const { isLogin, vendorId } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [isvisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!validateEmail(email.trim())) {
      toast.error("Please enter valid Email Address");
    } else if (captchaValue == "") {
      toast.error("Please enter  Captcha");
    } else if (!validateCaptcha(captcha, captchaValue)) {
      toast.warning("Please enter valid  Captcha");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/forgot", {
        method: "POST",
        body: JSON.stringify({ email: email }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setCaptcha(() => generateString(6));
          setCaptchaValue("");

          setIsVisible(false);
          if (res.status == true) {
            toast(`${res.message}`, {
              type: "success",
            });
            saveData("forgotEmail", email);
            setTimeout(() => {
              navigate("/codeauthentication");
            }, 1000);
          } else {
            toast(`${res.message}`, {
              type: "error",
            });
          }
          // RenderHandler(true);
        })
        .catch((err) => {
          setIsVisible(false);
          setCaptchaValue("");
          console.log("e", err);
        });
    }
  };
  const handleGenerateCaptcha = () => {
    setCaptcha(() => generateString(6));
  };
  useEffect(() => {
    if (isLogin) {
      navigate("/rfqs");
    }
  }, []);
  return (
    <>
      <div
        className={styles.mainDivFP}
        style={{
          backgroundImage: `url(${IMAGE_PATH}loginLeftBg.svg),
    url(${IMAGE_PATH}forgetPasswordRightBg.svg)`,
        }}
      >
        <div className={styles.topFP}>
          <h1>FORGOT PASSWORD</h1>
          <div
            className="forgotPasswordCard"
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              textAlign: "left",
              border: "1px solid lightGrey",
              borderRadius: "0.5rem",
              backgroundColor: "#fbfafa",
              padding: "40px 80px",
            }}
          >
            <TextInputField
              label="Email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.inputDiv}
            />
            <TextInputField
              label="Captcha Code"
              placeholder="Captcha Code"
              value={captchaValue}
              onChange={(e) => setCaptchaValue(e.target.value)}
              className={styles.inputDiv}
            />
            <div>
              {/* <LoadCanvasTemplateNoReload className="captchaDiv" /> */}
              <Captcha captcha={captcha} setCaptcha={setCaptcha} />
            </div>
            <div className={styles.instructionDivFP}>
              <p>
                Please enter the code shown in the above <br />
                text box.There are no zeros in the image.
              </p>
            </div>
            <div>
              {!isvisible ? (
                <Button
                  className={styles.nextBtnFP}
                  id="poppinFontLogin"
                  onClick={handleSubmit}
                >
                  RESET PASSWORD
                </Button>
              ) : (
                <Button
                  disabled
                  className={styles.nextBtnDisbaledFP}
                  id="poppinFontLogin"
                >
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "white", marginRight: "10px" }}
                  ></i>
                  RESET PASSWORD
                </Button>
              )}
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    </>
  );
};
